"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Navigation/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _changelog = require('shared/data/changelog');
var _hooks = require('web/screens/Settings/hooks');
var _ui = require('web/services/ui');

var _App = require('web/screens/App');
var _Notice = require('web/screens/Settings/Notice'); var _Notice2 = _interopRequireDefault(_Notice);
var _WhatsNew = require('web/components/WhatsNew');
var _NavItem = require('./NavItem'); var _NavItem2 = _interopRequireDefault(_NavItem);

// Stays after the What's New row is dismissed.
const openWhatsNew = () => window.open(_changelog.whatsNewUrl, '_blank', 'noopener')









// Holds the Account item's row while the list loads on an Account page, so
// it doesn't pop in under the person (F-3). Anywhere else, most people have
// no Account item, and a held row would pop out instead.
const AccountRowPlaceholder = () => (
  _react2.default.createElement('div', { className: "settings--nav-item--wrapper", role: "presentation", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}
    , _react2.default.createElement('div', { className: "settings--nav-item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}
      , _react2.default.createElement('div', { className: "settings--nav-item--icon icon-org" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}} )
      , _react2.default.createElement('span', { className: "settings--skeleton-cell settings--nav-item--skeleton" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}} )
    )
  )
)

const Navigation = ({ memberOrgs, managedAccounts, isAccountsLoading = false, pathname }) => {
  const navOptions = _hooks.useMenu.call(void 0, { memberOrgs, managedAccounts, pathname })
  const holdAccountRow = isAccountsLoading && pathname.startsWith('/settings/account')
  // The desktop sidebar has the What's New pill instead.
  const isDesktop = _ui.useScreenType.call(void 0, ) === 'desktop'

  return (
    _react2.default.createElement(_App.NavigationMenu, { className: "settings--nav-menu", __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
      , _react2.default.createElement('div', { className: "settings--nav-header--wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}
        , _react2.default.createElement('h1', { className: "settings--nav-header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}, "Settings")
      )
      ,  !isDesktop && _react2.default.createElement(_WhatsNew.WhatsNewSettingsRow, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 49}} ) 
      , _react2.default.createElement('div', { className: "settings--nav-body", role: "menu", __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}
        ,  navOptions.map(l => (
          _react2.default.createElement(_react2.default.Fragment, { key: l.route, __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
            , _react2.default.createElement(_NavItem2.default, {
              label: l.label,
              iconClassName: l.icon,
              isActive: !!l.isActive,
              gotoRoute: l.gotoRoute,
              subroutes: l.subroutes, __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}
            )
            ,  holdAccountRow && l.route === 'security' && _react2.default.createElement(AccountRowPlaceholder, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 60}} ) 
          )
        ))
        , _react2.default.createElement(_NavItem2.default, {
          gotoRoute: openWhatsNew,
          iconClassName: "whats-new",
          label: "What's new" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}
        )
        , _react2.default.createElement(_NavItem2.default, {
          gotoRoute: _actions2.default.logout,
          iconClassName: "logout",
          label: "Log out" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}
        )
      )
      , _react2.default.createElement(_Notice2.default, { className: "settings--nav-notice", __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}} )
    )
  )
}

exports. default = Navigation
